import React from "react";
import FeaturesCard from "../../cards/featuresCard";
import { useTranslation } from "react-i18next";

const Features = () => {
  const { t } = useTranslation();

  const featuresData = [
    {
      icon: "../../assets/icons/search.svg",
      // title: t("home.experience.one.title"),
      title: "Documents Drafting",
      description: [
        "Over 100 legal documents",
        "Risk free of human error",
        "Collaborative team edits",
      ],
    },
    {
      icon: "../../assets/icons/file.png",
      // title: t("home.experience.two.title"),
      title: "Legal Queries",
      description: [
        "Real-time legal changes",
        "24/7 legal support",
        "Seamless integration with case management",
      ],
    },
    {
      icon: "../../assets/icons/clock.png",
      // title: t("home.experience.three.title"),
      title: "Task scheduling & reminders",
      description: [
        "Suggestions of relevant next steps to your case",
        "Priority-based task scheduling",
        "Client progression notifications",
      ],
    },
    {
      icon: "../../assets/icons/file_img.svg",
      // title: t("home.experience.four.title"),
      title: "Donna AI",
      description: ["Connection to your virtual assistant"],
    },
  ];

  return (
    <>
      <div className="w-100 rounded-[38px] bg-[#F0F2F4] overflow-hidden">
        <div
          id="features"
          className="w-[80%] max-xxxl:w-[90%] m-auto pt-[32px]"
        >
          <h3 className="max-w-[1100px] uppercase leading-[70px] tracking-[-3px] font-sora max-md:leading-[48px]">
            {t("home.experience.title")}
          </h3>
          <div className="flex  gap-[10px] max-xxxl:justify-start">
            <img
              src="../../assets/images/home/freepikAI.png"
              alt=""
              className="md-m:hidden "
            />
            <div className="features-wrapper w-full md-lg:w-full max-sm:grid-cols-1 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 justify-items-center  gap-x-[30px] gap-y-[50px] sm-s:gap-0">
              {featuresData.map((feature, index) => (
                <FeaturesCard
                  key={index}
                  icon={feature.icon}
                  title={feature.title}
                  description={feature.description}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Features;
